//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../library/umum";

export default {
  data() {
    return {
      listData: [],
      listKegiatan: [],

      page_limit: 8,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      UMUM: UMUM
    };
  },
  methods: {
    getView: function() {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_PERPUSTAKAAN_KEG + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          page_limit: this.page_limit,
          cari_value: this.cari_value,
          des_kel : this.$store.state.ID_DES_KEL,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.listKegiatan = res_data.data;
          this.page_last = res_data.jmlData;
          this.$store.commit("hideLoading");
          console.log(res_data);
        });
    },

    pushKegiatan: function(id) {
      this.$router.push("/kegiatanPerpusDetile?KegiatanperpusId=" + id);
    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    }
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.getView();
  }
};
